/**
 * Setting name -> [index, type] table.
 *
 * Generated from PyMOL's `layer1/SettingInfo.h` (the `REC_*` macro table),
 * mirroring `SettingInfo[index].{index,type}`. `index` is the frozen setting id
 * a session serializes; `type` is PyMOL's `cSetting_*` type tag
 * (`layer1/Setting.h:114-120`): 1=boolean, 2=int, 3=float, 4=float3, 5=color,
 * 6=string. Used by `get_object_settings` to reproduce the C-layer
 * `SettingAsPyList`/`get_list` tuple shape `[index, type, value]`.
 *
 * The blank/retired slot (index 83) is omitted. Do not edit by hand.
 */

export const SETTING_INDEX_TYPE: Readonly<Record<string, readonly [number, number]>> = {
  "bonding_vdw_cutoff": [0, 3],
  "min_mesh_spacing": [1, 3],
  "dot_density": [2, 2],
  "dot_mode": [3, 2],
  "solvent_radius": [4, 3],
  "sel_counter": [5, 2],
  "bg_rgb": [6, 5],
  "ambient": [7, 3],
  "direct": [8, 3],
  "reflect": [9, 3],
  "light": [10, 4],
  "power": [11, 3],
  "antialias": [12, 2],
  "cavity_cull": [13, 2],
  "gl_ambient": [14, 3],
  "single_image": [15, 1],
  "movie_delay": [16, 3],
  "ribbon_power": [17, 3],
  "ribbon_power_b": [18, 3],
  "ribbon_sampling": [19, 2],
  "ribbon_radius": [20, 3],
  "stick_radius": [21, 3],
  "hash_max": [22, 2],
  "orthoscopic": [23, 1],
  "spec_reflect": [24, 3],
  "spec_power": [25, 3],
  "sweep_angle": [26, 3],
  "sweep_speed": [27, 3],
  "dot_hydrogens": [28, 1],
  "dot_radius": [29, 3],
  "ray_trace_frames": [30, 1],
  "cache_frames": [31, 1],
  "trim_dots": [32, 1],
  "cull_spheres": [33, 2],
  "test1": [34, 3],
  "test2": [35, 3],
  "surface_best": [36, 3],
  "surface_normal": [37, 3],
  "surface_quality": [38, 2],
  "surface_proximity": [39, 1],
  "normal_workaround": [40, 1],
  "stereo_angle": [41, 3],
  "stereo_shift": [42, 3],
  "line_smooth": [43, 1],
  "line_width": [44, 3],
  "half_bonds": [45, 1],
  "stick_quality": [46, 2],
  "stick_overlap": [47, 3],
  "stick_nub": [48, 3],
  "all_states": [49, 1],
  "pickable": [50, 1],
  "auto_show_lines": [51, 1],
  "idle_delay": [52, 3],
  "no_idle": [53, 3],
  "fast_idle": [54, 3],
  "slow_idle": [55, 3],
  "rock_delay": [56, 3],
  "dist_counter": [57, 2],
  "dash_length": [58, 3],
  "dash_gap": [59, 3],
  "auto_zoom": [60, 2],
  "overlay": [61, 2],
  "text": [62, 1],
  "button_mode": [63, 2],
  "valence": [64, 1],
  "nonbonded_size": [65, 3],
  "label_color": [66, 5],
  "ray_trace_fog": [67, 3],
  "spheroid_scale": [68, 3],
  "ray_trace_fog_start": [69, 3],
  "spheroid_smooth": [70, 3],
  "spheroid_fill": [71, 3],
  "auto_show_nonbonded": [72, 1],
  "cache_display": [73, 1],
  "mesh_radius": [74, 3],
  "backface_cull": [75, 1],
  "gamma": [76, 3],
  "dot_width": [77, 3],
  "auto_show_selections": [78, 1],
  "auto_hide_selections": [79, 1],
  "selection_width": [80, 3],
  "selection_overlay": [81, 3],
  "static_singletons": [82, 1],
  "depth_cue": [84, 1],
  "specular": [85, 3],
  "shininess": [86, 3],
  "sphere_quality": [87, 2],
  "fog": [88, 3],
  "isomesh_auto_state": [89, 1],
  "mesh_width": [90, 3],
  "cartoon_sampling": [91, 2],
  "cartoon_loop_radius": [92, 3],
  "cartoon_loop_quality": [93, 3],
  "cartoon_power": [94, 3],
  "cartoon_power_b": [95, 3],
  "cartoon_rect_length": [96, 3],
  "cartoon_rect_width": [97, 3],
  "internal_gui_width": [98, 2],
  "internal_gui": [99, 1],
  "cartoon_oval_length": [100, 3],
  "cartoon_oval_width": [101, 3],
  "cartoon_oval_quality": [102, 3],
  "cartoon_tube_radius": [103, 3],
  "cartoon_tube_quality": [104, 3],
  "cartoon_debug": [105, 2],
  "ribbon_width": [106, 3],
  "dash_width": [107, 3],
  "dash_radius": [108, 3],
  "cgo_ray_width_scale": [109, 3],
  "line_radius": [110, 3],
  "cartoon_round_helices": [111, 1],
  "cartoon_refine_normals": [112, 2],
  "cartoon_flat_sheets": [113, 1],
  "cartoon_smooth_loops": [114, 1],
  "cartoon_dumbbell_length": [115, 3],
  "cartoon_dumbbell_width": [116, 3],
  "cartoon_dumbbell_radius": [117, 3],
  "cartoon_fancy_helices": [118, 1],
  "cartoon_fancy_sheets": [119, 1],
  "ignore_pdb_segi": [120, 1],
  "ribbon_throw": [121, 3],
  "cartoon_throw": [122, 3],
  "cartoon_refine": [123, 2],
  "cartoon_refine_tips": [124, 2],
  "cartoon_discrete_colors": [125, 1],
  "normalize_ccp4_maps": [126, 2],
  "surface_poor": [127, 3],
  "internal_feedback": [128, 2],
  "cgo_line_width": [129, 3],
  "cgo_line_radius": [130, 3],
  "logging": [131, 2],
  "robust_logs": [132, 1],
  "log_box_selections": [133, 1],
  "log_conformations": [134, 1],
  "valence_size": [135, 3],
  "surface_miserable": [136, 3],
  "ray_opaque_background": [137, 2],
  "transparency": [138, 3],
  "ray_texture": [139, 2],
  "ray_texture_settings": [140, 4],
  "suspend_updates": [141, 1],
  "full_screen": [142, 1],
  "surface_mode": [143, 2],
  "surface_color": [144, 5],
  "mesh_mode": [145, 2],
  "mesh_color": [146, 5],
  "auto_indicate_flags": [147, 1],
  "surface_debug": [148, 2],
  "ray_improve_shadows": [149, 3],
  "smooth_color_triangle": [150, 1],
  "ray_default_renderer": [151, 2],
  "field_of_view": [152, 3],
  "reflect_power": [153, 3],
  "preserve_chempy_ids": [154, 1],
  "sphere_scale": [155, 3],
  "two_sided_lighting": [156, 2],
  "secondary_structure": [157, 2],
  "auto_remove_hydrogens": [158, 1],
  "raise_exceptions": [159, 1],
  "stop_on_exceptions": [160, 1],
  "sculpting": [161, 1],
  "auto_sculpt": [162, 1],
  "sculpt_vdw_scale": [163, 3],
  "sculpt_vdw_scale14": [164, 3],
  "sculpt_vdw_weight": [165, 3],
  "sculpt_vdw_weight14": [166, 3],
  "sculpt_bond_weight": [167, 3],
  "sculpt_angl_weight": [168, 3],
  "sculpt_pyra_weight": [169, 3],
  "sculpt_plan_weight": [170, 3],
  "sculpting_cycles": [171, 2],
  "sphere_transparency": [172, 3],
  "sphere_color": [173, 5],
  "sculpt_field_mask": [174, 2],
  "sculpt_hb_overlap": [175, 3],
  "sculpt_hb_overlap_base": [176, 3],
  "legacy_vdw_radii": [177, 1],
  "sculpt_memory": [178, 1],
  "connect_mode": [179, 2],
  "cartoon_cylindrical_helices": [180, 2],
  "cartoon_helix_radius": [181, 3],
  "connect_cutoff": [182, 3],
  "save_pdb_ss": [183, 1],
  "sculpt_line_weight": [184, 3],
  "fit_iterations": [185, 2],
  "fit_tolerance": [186, 3],
  "batch_prefix": [187, 6],
  "stereo_mode": [188, 2],
  "cgo_sphere_quality": [189, 2],
  "pdb_literal_names": [190, 1],
  "wrap_output": [191, 1],
  "fog_start": [192, 3],
  "state": [193, 2],
  "frame": [194, 2],
  "ray_shadow": [195, 1],
  "ribbon_trace_atoms": [196, 2],
  "security": [197, 2],
  "stick_transparency": [198, 3],
  "ray_transparency_shadows": [199, 1],
  "session_version_check": [200, 2],
  "ray_transparency_specular": [201, 3],
  "stereo_double_pump_mono": [202, 1],
  "sphere_solvent": [203, 1],
  "mesh_quality": [204, 2],
  "mesh_solvent": [205, 2],
  "dot_solvent": [206, 1],
  "ray_shadow_fudge": [207, 3],
  "ray_triangle_fudge": [208, 3],
  "debug_pick": [209, 2],
  "dot_color": [210, 5],
  "mouse_limit": [211, 3],
  "mouse_scale": [212, 3],
  "transparency_mode": [213, 2],
  "clamp_colors": [214, 1],
  "pymol_space_max_red": [215, 3],
  "pymol_space_max_green": [216, 3],
  "pymol_space_max_blue": [217, 3],
  "pymol_space_min_factor": [218, 3],
  "roving_origin": [219, 1],
  "roving_lines": [220, 3],
  "roving_sticks": [221, 3],
  "roving_spheres": [222, 3],
  "roving_labels": [223, 3],
  "roving_delay": [224, 3],
  "roving_selection": [225, 6],
  "roving_byres": [226, 1],
  "roving_ribbon": [227, 3],
  "roving_cartoon": [228, 3],
  "roving_polar_contacts": [229, 3],
  "roving_polar_cutoff": [230, 3],
  "roving_nonbonded": [231, 3],
  "float_labels": [232, 2],
  "roving_detail": [233, 1],
  "roving_nb_spheres": [234, 3],
  "ribbon_color": [235, 5],
  "cartoon_color": [236, 5],
  "ribbon_smooth": [237, 2],
  "auto_color": [238, 1],
  "auto_color_next": [239, 2],
  "ray_interior_color": [240, 5],
  "cartoon_highlight_color": [241, 5],
  "coulomb_units_factor": [242, 3],
  "coulomb_dielectric": [243, 3],
  "ray_interior_shadows": [244, 1],
  "ray_interior_texture": [245, 2],
  "roving_map1_name": [246, 6],
  "roving_map2_name": [247, 6],
  "roving_map3_name": [248, 6],
  "roving_map1_level": [249, 3],
  "roving_map2_level": [250, 3],
  "roving_map3_level": [251, 3],
  "roving_isomesh": [252, 3],
  "roving_isosurface": [253, 3],
  "scenes_changed": [254, 1],
  "gaussian_b_adjust": [255, 3],
  "pdb_standard_order": [256, 1],
  "cartoon_smooth_first": [257, 2],
  "cartoon_smooth_last": [258, 2],
  "cartoon_smooth_cycles": [259, 2],
  "cartoon_flat_cycles": [260, 2],
  "max_threads": [261, 2],
  "show_progress": [262, 2],
  "use_display_lists": [263, 2],
  "cache_memory": [264, 2],
  "simplify_display_lists": [265, 1],
  "retain_order": [266, 2],
  "pdb_hetatm_sort": [267, 2],
  "pdb_use_ter_records": [268, 2],
  "cartoon_trace_atoms": [269, 2],
  "ray_oversample_cutoff": [270, 2],
  "gaussian_resolution": [271, 3],
  "gaussian_b_floor": [272, 3],
  "sculpt_nb_interval": [273, 2],
  "sculpt_tors_weight": [274, 3],
  "sculpt_tors_tolerance": [275, 3],
  "stick_ball": [276, 1],
  "stick_ball_ratio": [277, 3],
  "stick_fixed_radius": [278, 1],
  "cartoon_transparency": [279, 3],
  "dash_round_ends": [280, 1],
  "h_bond_max_angle": [281, 3],
  "h_bond_cutoff_center": [282, 3],
  "h_bond_cutoff_edge": [283, 3],
  "h_bond_power_a": [284, 3],
  "h_bond_power_b": [285, 3],
  "h_bond_cone": [286, 3],
  "ss_helix_psi_target": [287, 3],
  "ss_helix_psi_include": [288, 3],
  "ss_helix_psi_exclude": [289, 3],
  "ss_helix_phi_target": [290, 3],
  "ss_helix_phi_include": [291, 3],
  "ss_helix_phi_exclude": [292, 3],
  "ss_strand_psi_target": [293, 3],
  "ss_strand_psi_include": [294, 3],
  "ss_strand_psi_exclude": [295, 3],
  "ss_strand_phi_target": [296, 3],
  "ss_strand_phi_include": [297, 3],
  "ss_strand_phi_exclude": [298, 3],
  "movie_loop": [299, 1],
  "pdb_retain_ids": [300, 1],
  "pdb_no_end_record": [301, 1],
  "cgo_dot_width": [302, 3],
  "cgo_dot_radius": [303, 3],
  "defer_updates": [304, 1],
  "normalize_o_maps": [305, 1],
  "swap_dsn6_bytes": [306, 1],
  "pdb_insertions_go_first": [307, 1],
  "roving_origin_z": [308, 1],
  "roving_origin_z_cushion": [309, 3],
  "specular_intensity": [310, 3],
  "overlay_lines": [311, 2],
  "ray_transparency_spec_cut": [312, 3],
  "internal_prompt": [313, 1],
  "normalize_grd_maps": [314, 1],
  "ray_blend_colors": [315, 1],
  "ray_blend_red": [316, 3],
  "ray_blend_green": [317, 3],
  "ray_blend_blue": [318, 3],
  "png_screen_gamma": [319, 3],
  "png_file_gamma": [320, 3],
  "editor_label_fragments": [321, 1],
  "internal_gui_control_size": [322, 2],
  "auto_dss": [323, 1],
  "transparency_picking_mode": [324, 2],
  "virtual_trackball": [325, 2],
  "pdb_reformat_names_mode": [326, 2],
  "ray_pixel_scale": [327, 3],
  "label_font_id": [328, 2],
  "pdb_conect_all": [329, 1],
  "button_mode_name": [330, 6],
  "surface_type": [331, 2],
  "dot_normals": [332, 1],
  "session_migration": [333, 1],
  "mesh_normals": [334, 1],
  "mesh_type": [335, 2],
  "dot_lighting": [336, 1],
  "mesh_lighting": [337, 1],
  "surface_solvent": [338, 1],
  "triangle_max_passes": [339, 2],
  "ray_interior_reflect": [340, 3],
  "internal_gui_mode": [341, 2],
  "surface_carve_selection": [342, 6],
  "surface_carve_state": [343, 2],
  "surface_carve_cutoff": [344, 3],
  "surface_clear_selection": [345, 6],
  "surface_clear_state": [346, 2],
  "surface_clear_cutoff": [347, 3],
  "surface_trim_cutoff": [348, 3],
  "surface_trim_factor": [349, 3],
  "ray_max_passes": [350, 2],
  "active_selections": [351, 1],
  "ray_transparency_contrast": [352, 3],
  "seq_view": [353, 1],
  "mouse_selection_mode": [354, 2],
  "seq_view_label_spacing": [355, 2],
  "seq_view_label_start": [356, 2],
  "seq_view_format": [357, 2],
  "seq_view_location": [358, 2],
  "seq_view_overlay": [359, 1],
  "auto_classify_atoms": [360, 1],
  "cartoon_nucleic_acid_mode": [361, 2],
  "seq_view_color": [362, 5],
  "seq_view_label_mode": [363, 2],
  "surface_ramp_above_mode": [364, 2],
  "stereo": [365, 1],
  "wizard_prompt_mode": [366, 2],
  "coulomb_cutoff": [367, 3],
  "slice_track_camera": [368, 1],
  "slice_height_scale": [369, 3],
  "slice_height_map": [370, 1],
  "slice_grid": [371, 3],
  "slice_dynamic_grid": [372, 1],
  "slice_dynamic_grid_resolution": [373, 3],
  "pdb_insure_orthogonal": [374, 1],
  "ray_direct_shade": [375, 3],
  "stick_color": [376, 5],
  "cartoon_putty_radius": [377, 3],
  "cartoon_putty_quality": [378, 3],
  "cartoon_putty_scale_min": [379, 3],
  "cartoon_putty_scale_max": [380, 3],
  "cartoon_putty_scale_power": [381, 3],
  "cartoon_putty_range": [382, 3],
  "cartoon_side_chain_helper": [383, 1],
  "surface_optimize_subsets": [384, 1],
  "multiplex": [385, 2],
  "texture_fonts": [386, 1],
  "pqr_no_chain_id": [387, 1],
  "animation": [388, 1],
  "animation_duration": [389, 3],
  "scene_animation": [390, 2],
  "line_stick_helper": [391, 1],
  "ray_orthoscopic": [392, 2],
  "ribbon_side_chain_helper": [393, 2],
  "selection_width_max": [394, 3],
  "selection_width_scale": [395, 3],
  "scene_current_name": [396, 6],
  "presentation": [397, 1],
  "presentation_mode": [398, 2],
  "pdb_truncate_residue_name": [399, 1],
  "scene_loop": [400, 1],
  "sweep_mode": [401, 2],
  "sweep_phase": [402, 3],
  "scene_restart_movie_delay": [403, 1],
  "mouse_restart_movie_delay": [404, 1],
  "angle_size": [405, 3],
  "angle_label_position": [406, 3],
  "dihedral_size": [407, 3],
  "dihedral_label_position": [408, 3],
  "defer_builds_mode": [409, 2],
  "seq_view_discrete_by_state": [410, 1],
  "scene_animation_duration": [411, 3],
  "wildcard": [412, 6],
  "atom_name_wildcard": [413, 6],
  "ignore_case": [414, 1],
  "presentation_auto_quit": [415, 1],
  "editor_auto_dihedral": [416, 1],
  "presentation_auto_start": [417, 1],
  "validate_object_names": [418, 1],
  "unused_boolean_def_true": [419, 1],
  "auto_show_spheres": [420, 1],
  "sphere_mode": [421, 2],
  "sphere_point_max_size": [422, 3],
  "sphere_point_size": [423, 3],
  "pdb_honor_model_number": [424, 1],
  "rank_assisted_sorts": [425, 1],
  "ribbon_nucleic_acid_mode": [426, 2],
  "cartoon_ring_mode": [427, 2],
  "cartoon_ring_width": [428, 3],
  "cartoon_ring_color": [429, 5],
  "cartoon_ring_finder": [430, 2],
  "cartoon_tube_cap": [431, 2],
  "cartoon_loop_cap": [432, 2],
  "nvidia_bugs": [433, 2],
  "image_dots_per_inch": [434, 3],
  "opaque_background": [435, 1],
  "draw_frames": [436, 1],
  "show_alpha_checker": [437, 1],
  "matrix_mode": [438, 2],
  "editor_auto_origin": [439, 1],
  "session_file": [440, 6],
  "cgo_transparency": [441, 3],
  "legacy_mouse_zoom": [442, 1],
  "auto_number_selections": [443, 1],
  "sculpt_vdw_vis_mode": [444, 2],
  "sculpt_vdw_vis_min": [445, 3],
  "sculpt_vdw_vis_mid": [446, 3],
  "sculpt_vdw_vis_max": [447, 3],
  "cartoon_ladder_mode": [448, 2],
  "cartoon_ladder_radius": [449, 3],
  "cartoon_ladder_color": [450, 5],
  "cartoon_nucleic_acid_color": [451, 5],
  "cartoon_ring_transparency": [452, 3],
  "label_size": [453, 3],
  "spec_direct": [454, 3],
  "light_count": [455, 2],
  "light2": [456, 4],
  "light3": [457, 4],
  "hide_underscore_names": [458, 1],
  "selection_round_points": [459, 1],
  "distance_exclusion": [460, 2],
  "h_bond_exclusion": [461, 2],
  "label_shadow_mode": [462, 2],
  "light4": [463, 4],
  "light5": [464, 4],
  "light6": [465, 4],
  "light7": [466, 4],
  "label_outline_color": [467, 5],
  "ray_trace_mode": [468, 2],
  "ray_trace_gain": [469, 3],
  "selection_visible_only": [470, 1],
  "label_position": [471, 4],
  "ray_trace_depth_factor": [472, 3],
  "ray_trace_slope_factor": [473, 3],
  "ray_trace_disco_factor": [474, 3],
  "ray_shadow_decay_factor": [475, 3],
  "ray_interior_mode": [476, 2],
  "ray_legacy_lighting": [477, 3],
  "sculpt_auto_center": [478, 1],
  "pdb_discrete_chains": [479, 2],
  "pdb_unbond_cations": [480, 2],
  "sculpt_tri_scale": [481, 3],
  "sculpt_tri_weight": [482, 3],
  "sculpt_tri_min": [483, 2],
  "sculpt_tri_max": [484, 2],
  "sculpt_tri_mode": [485, 2],
  "pdb_echo_tags": [486, 6],
  "connect_bonded": [487, 1],
  "spec_direct_power": [488, 3],
  "light8": [489, 4],
  "light9": [490, 4],
  "ray_shadow_decay_range": [491, 3],
  "spec_count": [492, 2],
  "sculpt_min_scale": [493, 3],
  "sculpt_min_weight": [494, 3],
  "sculpt_min_min": [495, 3],
  "sculpt_min_max": [496, 3],
  "sculpt_max_scale": [497, 3],
  "sculpt_max_weight": [498, 3],
  "sculpt_max_min": [499, 3],
  "sculpt_max_max": [500, 3],
  "surface_circumscribe": [501, 2],
  "sculpt_avd_weight": [502, 3],
  "sculpt_avd_gap": [503, 3],
  "sculpt_avd_range": [504, 3],
  "sculpt_avd_excl": [505, 2],
  "async_builds": [506, 1],
  "fetch_path": [507, 6],
  "cartoon_ring_radius": [508, 3],
  "ray_color_ramps": [509, 1],
  "ray_hint_camera": [510, 3],
  "ray_hint_shadow": [511, 3],
  "stick_valence_scale": [512, 3],
  "seq_view_alignment": [513, 6],
  "seq_view_unaligned_mode": [514, 2],
  "seq_view_unaligned_color": [515, 5],
  "seq_view_fill_char": [516, 6],
  "seq_view_fill_color": [517, 5],
  "seq_view_label_color": [518, 5],
  "surface_carve_normal_cutoff": [519, 3],
  "trace_atoms_mode": [520, 2],
  "session_changed": [521, 1],
  "ray_clip_shadows": [522, 1],
  "mouse_wheel_scale": [523, 3],
  "nonbonded_transparency": [524, 3],
  "ray_spec_local": [525, 1],
  "line_color": [526, 5],
  "ray_label_specular": [527, 3],
  "mesh_skip": [528, 2],
  "label_digits": [529, 2],
  "label_distance_digits": [530, 2],
  "label_angle_digits": [531, 2],
  "label_dihedral_digits": [532, 2],
  "surface_negative_visible": [533, 1],
  "surface_negative_color": [534, 5],
  "mesh_negative_visible": [535, 1],
  "mesh_negative_color": [536, 5],
  "group_auto_mode": [537, 2],
  "group_full_member_names": [538, 2],
  "gradient_max_length": [539, 3],
  "gradient_min_length": [540, 3],
  "gradient_min_slope": [541, 3],
  "gradient_normal_min_dot": [542, 3],
  "gradient_step_size": [543, 3],
  "gradient_spacing": [544, 2],
  "gradient_symmetry": [545, 3],
  "ray_trace_color": [546, 5],
  "group_arrow_prefix": [547, 1],
  "suppress_hidden": [548, 1],
  "session_compression": [549, 1],
  "movie_fps": [550, 3],
  "ray_transparency_oblique": [551, 3],
  "ray_trace_trans_cutoff": [552, 3],
  "ray_trace_persist_cutoff": [553, 3],
  "ray_transparency_oblique_power": [554, 3],
  "ray_scatter": [555, 3],
  "h_bond_from_proton": [556, 1],
  "auto_copy_images": [557, 1],
  "moe_separate_chains": [558, 2],
  "transparency_global_sort": [559, 1],
  "hide_long_bonds": [560, 1],
  "auto_rename_duplicate_objects": [561, 1],
  "pdb_hetatm_guess_valences": [562, 1],
  "ellipsoid_quality": [563, 2],
  "cgo_ellipsoid_quality": [564, 2],
  "movie_animate_by_frame": [565, 1],
  "ramp_blend_nearby_colors": [566, 1],
  "auto_defer_builds": [567, 2],
  "ellipsoid_probability": [568, 3],
  "ellipsoid_scale": [569, 3],
  "ellipsoid_color": [570, 5],
  "ellipsoid_transparency": [571, 3],
  "movie_rock": [572, 2],
  "cache_mode": [573, 2],
  "dash_color": [574, 5],
  "angle_color": [575, 5],
  "dihedral_color": [576, 5],
  "grid_mode": [577, 2],
  "cache_max": [578, 2],
  "grid_slot": [579, 2],
  "grid_max": [580, 2],
  "cartoon_putty_transform": [581, 2],
  "rock": [582, 1],
  "cone_quality": [583, 2],
  "pdb_formal_charges": [584, 1],
  "ati_bugs": [585, 2],
  "geometry_export_mode": [586, 2],
  "mouse_grid": [587, 1],
  "mesh_cutoff": [588, 3],
  "mesh_carve_selection": [589, 6],
  "mesh_carve_state": [590, 2],
  "mesh_carve_cutoff": [591, 3],
  "mesh_clear_selection": [592, 6],
  "mesh_clear_state": [593, 2],
  "mesh_clear_cutoff": [594, 3],
  "mesh_grid_max": [595, 2],
  "session_cache_optimize": [596, 2],
  "sdof_drag_scale": [597, 3],
  "scene_buttons_mode": [598, 2],
  "scene_buttons": [599, 1],
  "map_auto_expand_sym": [600, 1],
  "image_copy_always": [601, 1],
  "max_ups": [602, 2],
  "auto_overlay": [603, 2],
  "stick_ball_color": [604, 5],
  "stick_h_scale": [605, 3],
  "sculpt_pyra_inv_weight": [606, 3],
  "keep_alive": [607, 1],
  "fit_kabsch": [608, 2],
  "stereo_dynamic_strength": [609, 3],
  "dynamic_width": [610, 1],
  "dynamic_width_factor": [611, 3],
  "dynamic_width_min": [612, 3],
  "dynamic_width_max": [613, 3],
  "draw_mode": [614, 2],
  "clean_electro_mode": [615, 2],
  "valence_mode": [616, 2],
  "show_frame_rate": [617, 1],
  "movie_panel": [618, 2],
  "mouse_z_scale": [619, 3],
  "movie_auto_store": [620, 1],
  "movie_auto_interpolate": [621, 1],
  "movie_panel_row_height": [622, 2],
  "scene_frame_mode": [623, 2],
  "surface_cavity_mode": [624, 2],
  "surface_cavity_radius": [625, 3],
  "surface_cavity_cutoff": [626, 3],
  "motion_power": [627, 3],
  "motion_bias": [628, 3],
  "motion_simple": [629, 2],
  "motion_linear": [630, 3],
  "motion_hand": [631, 2],
  "pdb_ignore_conect": [632, 1],
  "editor_bond_cycle_mode": [633, 1],
  "movie_quality": [634, 2],
  "label_anchor": [635, 6],
  "fetch_host": [636, 6],
  "dynamic_measures": [637, 1],
  "neighbor_cutoff": [638, 3],
  "heavy_neighbor_cutoff": [639, 3],
  "polar_neighbor_cutoff": [640, 3],
  "surface_residue_cutoff": [641, 3],
  "surface_use_shader": [642, 1],
  "cartoon_use_shader": [643, 1],
  "stick_use_shader": [644, 1],
  "line_use_shader": [645, 1],
  "sphere_use_shader": [646, 1],
  "use_shaders": [647, 1],
  "shaders_from_disk": [648, 1],
  "volume_bit_depth": [649, 2],
  "volume_color": [650, 5],
  "volume_layers": [651, 3],
  "volume_data_range": [652, 3],
  "auto_defer_atom_count": [653, 2],
  "default_refmac_names": [654, 6],
  "default_phenix_names": [655, 6],
  "default_phenix_no_fill_names": [656, 6],
  "default_buster_names": [657, 6],
  "default_fofc_map_rep": [658, 6],
  "default_2fofc_map_rep": [659, 6],
  "atom_type_format": [660, 6],
  "autoclose_dialogs": [661, 1],
  "bg_gradient": [662, 2],
  "bg_rgb_top": [663, 5],
  "bg_rgb_bottom": [664, 5],
  "ray_volume": [665, 1],
  "ribbon_transparency": [666, 3],
  "state_counter_mode": [667, 2],
  "cgo_use_shader": [668, 1],
  "cgo_shader_ub_color": [669, 1],
  "cgo_shader_ub_normal": [670, 1],
  "cgo_lighting": [671, 2],
  "mesh_use_shader": [672, 1],
  "stick_debug": [673, 2],
  "cgo_debug": [674, 2],
  "stick_round_nub": [675, 2],
  "stick_good_geometry": [676, 2],
  "stick_as_cylinders": [677, 1],
  "mesh_as_cylinders": [678, 1],
  "line_as_cylinders": [679, 1],
  "ribbon_as_cylinders": [680, 1],
  "ribbon_use_shader": [681, 1],
  "excl_display_lists_shaders": [682, 1],
  "dash_use_shader": [683, 1],
  "dash_as_cylinders": [684, 1],
  "nonbonded_use_shader": [685, 1],
  "nonbonded_as_cylinders": [686, 1],
  "cylinders_shader_filter_faces": [687, 1],
  "nb_spheres_size": [688, 3],
  "nb_spheres_quality": [689, 2],
  "nb_spheres_use_shader": [690, 2],
  "render_as_cylinders": [691, 1],
  "alignment_as_cylinders": [692, 1],
  "cartoon_nucleic_acid_as_cylinders": [693, 2],
  "cgo_shader_ub_flags": [694, 1],
  "antialias_shader": [695, 2],
  "offscreen_rendering_multiplier": [696, 3],
  "cylinder_shader_ff_workaround": [697, 1],
  "surface_color_smoothing": [698, 2],
  "surface_color_smoothing_threshold": [699, 3],
  "dot_use_shader": [700, 1],
  "dot_as_spheres": [701, 1],
  "ambient_occlusion_mode": [702, 2],
  "ambient_occlusion_scale": [703, 3],
  "ambient_occlusion_smooth": [704, 2],
  "smooth_half_bonds": [705, 1],
  "anaglyph_mode": [706, 2],
  "edit_light": [707, 2],
  "suspend_undo": [708, 1],
  "suspend_undo_atom_count": [709, 2],
  "suspend_deferred": [710, 1],
  "pick_surface": [711, 1],
  "bg_image_filename": [712, 6],
  "bg_image_mode": [713, 2],
  "bg_image_tilesize": [714, 4],
  "bg_image_linear": [715, 1],
  "load_object_props_default": [716, 6],
  "load_atom_props_default": [717, 6],
  "label_placement_offset": [718, 4],
  "pdb_conect_nodup": [719, 1],
  "label_connector": [720, 1],
  "label_connector_mode": [721, 2],
  "label_connector_color": [722, 5],
  "label_connector_width": [723, 3],
  "label_connector_ext_length": [724, 3],
  "label_bg_color": [725, 5],
  "use_geometry_shaders": [726, 1],
  "label_relative_mode": [727, 2],
  "label_screen_point": [728, 4],
  "label_multiline_spacing": [729, 3],
  "label_multiline_justification": [730, 3],
  "label_padding": [731, 4],
  "label_bg_transparency": [732, 3],
  "label_bg_outline": [733, 1],
  "ray_label_connector_flat": [734, 1],
  "dash_transparency": [735, 3],
  "pick_labels": [736, 2],
  "label_z_target": [737, 2],
  "session_embeds_data": [738, 1],
  "volume_mode": [739, 2],
  "trilines": [740, 1],
  "collada_export_lighting": [741, 2],
  "collada_geometry_mode": [742, 2],
  "precomputed_lighting": [743, 1],
  "chromadepth": [744, 2],
  "pse_export_version": [745, 3],
  "cif_use_auth": [746, 1],
  "assembly": [747, 6],
  "cif_keepinmemory": [748, 1],
  "pse_binary_dump": [749, 1],
  "cartoon_gap_cutoff": [750, 2],
  "ignore_case_chain": [751, 1],
  "valence_zero_scale": [752, 3],
  "valence_zero_mode": [753, 2],
  "auto_show_classified": [754, 2],
  "collada_background_box": [755, 1],
  "pick32bit": [756, 1],
  "cartoon_all_alt": [757, 1],
  "display_scale_factor": [758, 2],
  "pick_shading": [759, 1],
  "fetch_type_default": [760, 6],
  "editor_auto_measure": [761, 1],
  "surface_smooth_edges": [762, 1],
  "chem_comp_cartn_use": [763, 2],
  "colored_feedback": [764, 1],
  "sdf_write_zero_order_bonds": [765, 1],
  "cif_metalc_as_zero_order_bonds": [766, 1],
  "seq_view_gap_mode": [767, 2],
  "internal_gui_name_color_mode": [768, 2],
  "openvr_gui_fov": [769, 3],
  "openvr_gui_alpha": [770, 3],
  "openvr_gui_use_alpha": [771, 2],
  "openvr_gui_scene_color": [772, 3],
  "openvr_gui_scene_alpha": [773, 3],
  "openvr_gui_back_color": [774, 3],
  "openvr_gui_back_alpha": [775, 3],
  "openvr_gui_use_backdrop": [776, 2],
  "openvr_gui_overlay": [777, 2],
  "openvr_gui_text": [778, 2],
  "openvr_disable_clipping": [779, 1],
  "openvr_near_plane": [780, 3],
  "openvr_far_plane": [781, 3],
  "openvr_cut_laser": [782, 1],
  "openvr_laser_width": [783, 3],
  "openvr_gui_distance": [784, 3],
  "cartoon_smooth_cylinder_cycles": [785, 2],
  "cartoon_smooth_cylinder_window": [786, 2],
  "isosurface_algorithm": [787, 2],
  "cell_centered": [788, 1],
  "halogen_bond_distance": [789, 3],
  "halogen_bond_as_donor_min_donor_angle": [790, 3],
  "halogen_bond_as_donor_min_acceptor_angle": [791, 3],
  "halogen_bond_as_acceptor_min_donor_angle": [792, 3],
  "halogen_bond_as_acceptor_min_acceptor_angle": [793, 3],
  "halogen_bond_as_acceptor_max_acceptor_angle": [794, 3],
  "salt_bridge_distance": [795, 3],
  "use_tessellation_shaders": [796, 1],
  "cell_color": [797, 5],
};
